import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { cities, mainCities } from "../data/cities";

export const CitiesSection = ({ showAll = false }) => {
  const displayCities = showAll ? cities : mainCities;

  return (
    <section className="section-padding bg-white" data-testid="cities-section">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mb-12">
          <span className="text-yellow-500 font-bold uppercase tracking-wider text-sm mb-4 block">
            Zone d'intervention
          </span>
          <h2 className="text-4xl md:text-5xl font-bold uppercase tracking-tight text-zinc-900 mb-6 font-heading">
            Serrurier dans votre ville
          </h2>
          <p className="text-lg text-zinc-600">
            Nous intervenons rapidement à Lieusaint et dans plus de 50 villes 
            de la zone de Sénart, Melun et alentours.
          </p>
        </div>

        {/* Cities Grid */}
        <div className={`grid gap-4 ${showAll ? 'grid-cols-2 md:grid-cols-4 lg:grid-cols-6' : 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4'}`}>
          {displayCities.map((city) => (
            <Link
              key={city.slug}
              to={`/serrurier/${city.slug}`}
              className="group flex items-center gap-3 bg-zinc-50 border border-zinc-200 rounded-sm px-4 py-3 transition-all duration-300 hover:border-yellow-400 hover:bg-yellow-50"
              data-testid={`city-link-${city.slug}`}
            >
              <MapPin className="w-4 h-4 text-yellow-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <span className="text-zinc-900 font-medium text-sm group-hover:text-yellow-600 transition-colors truncate block">
                  {city.name}
                </span>
                <span className="text-xs text-zinc-400">{city.postalCode}</span>
              </div>
            </Link>
          ))}
        </div>

        {/* View all link */}
        {!showAll && (
          <div className="mt-10 text-center">
            <Link
              to="/zones-intervention"
              className="inline-flex items-center gap-2 text-yellow-500 font-bold uppercase tracking-wide hover:text-yellow-600 transition-colors"
              data-testid="view-all-cities-link"
            >
              Voir toutes les villes d'intervention
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default CitiesSection;
